
  import { defineComponent, PropType } from 'vue';

  import FilterFactory from '@/common/components/redesigned/Filter/FilterFactory.vue';
  import { TFilter, TFilterConfig } from '@/common/components/redesigned/Filter/types/filter';

  export default defineComponent({
    name: 'FilterFactoryVed',
    components: {
      FilterFactory,
    },
    emits: {
      searchFilter: (filter: TFilter) => filter,
      updateFilter: (filter: TFilter) => filter,
    },
    props: {
      defaultFilter: {
        type: Object as PropType<TFilter>,
        required: true,
      },
      filtersConfig: {
        type: Array as PropType<TFilterConfig[]>,
        required: true,
      },
      readonlyPermissionCode: {
        type: Number,
      },
    },
    methods: {
      searchFilter(filter: TFilter) {
        this.$emit('searchFilter', filter);
      },
      updateFilter(filter: TFilter) {
        this.$emit('updateFilter', filter);
      },
    },
  });
